export { default as ReceiptHeadInfo } from './receipt-head-info';
